/** Tile animation duration (in ms). */
export const animationDuration = 100;

/** Default board size. */
export const defaultBoardSize = 4;

/** A list of supported board sizes. */
export const supportedBoardSizes = [3, 4, 5, 6];

/** Tile value of the victorious tile. */
export const victoryTileValue = 2048;

/** Grid gap (used for animations). */
export const gridGap = '1rem';
